export const SCHEDULE_PERIODS = [
    { label: 'Every 1 Day', value: 'EVERY_1_DAY' },
    { label: 'Every 2 Days', value: 'EVERY_2_DAY' },
    { label: 'Every 3 Days', value: 'EVERY_3_DAY' },
    { label: 'Every 4 Days', value: 'EVERY_4_DAY' },
    { label: 'Every 5 Days', value: 'EVERY_5_DAY' },
    { label: 'Every 6 Days', value: 'EVERY_6_DAY' },
]